import { render, staticRenderFns } from "./RqtaEditMain.vue?vue&type=template&id=72762b69&scoped=true&"
import script from "./RqtaEditMain.vue?vue&type=script&lang=js&"
export * from "./RqtaEditMain.vue?vue&type=script&lang=js&"
import style0 from "./RqtaEditMain.vue?vue&type=style&index=0&id=72762b69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72762b69",
  null
  
)

export default component.exports